<template>
  <v-dialog
      v-model="dialog"
      persistent
      width="700"
  >
    <v-card>
      <v-card-title
          class="headline green darken-2 white--text"
          primary-title
      >
        {{dialogTitle}} Tipo de Requerimento
      </v-card-title>

      <v-card-text>

        <v-form
            ref="form"
            v-model="valid"
        >
          <v-container>
            <v-layout>
              <v-flex xs4>
                <v-text-field
                    v-model="code"
                    :rules="requiredRules"
                    label="Código"
                    required
                />
              </v-flex>
              <v-flex xs4>
                <v-text-field
                    v-model="license_id"
                    :rules="requiredRules"
                    label="ID Licença Boletos"
                    required
                />
              </v-flex>
              <v-flex xs4>
                <v-text-field
                    v-model="acronym"
                    :rules="requiredRules"
                    label="Abreviação"
                />
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs6>
                <v-text-field
                    v-model="name"
                    :rules="requiredRules"
                    label="Nome"
                    required
                />
              </v-flex>
              <v-flex xs3>
                <v-checkbox
                    v-model="acceptDiscountCompanyType"
                    label="Há Desconto pelo Enquadramento?"
                    required
                />
              </v-flex>
              <v-flex xs3>
                <v-checkbox
                    v-model="show_for_selection"
                    label="Exibir na Criação de Checklists?"
                    required
                />
              </v-flex>
            </v-layout>
            <div class="mt-2">
              <span class="title">Zonas</span>
              <br>
              <span class="subtitle">Informe o valor em UPFAL</span>
              <v-layout wrap>
                <v-flex
                    class="pr-4"
                    xs3
                    v-for="taxTableZone in taxTableZonesAttributes"
                    :key="taxTableZone.id"
                >
                  <v-text-field
                      v-model="taxTableZone.weight"
                      :rules="requiredRules"
                      :label="taxTableZone.zone.name"
                  />
                </v-flex>
              </v-layout>
            </div>
          </v-container>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-layout justify-center>
          <v-btn
              :disabled="loading"
              flat
              @click="closeDialog()"
          >
            Cancelar
          </v-btn>

          <v-btn
              color="primary"
              flat
              :loading="loading"
              :disabled="!valid"
              @click="save()"
          >
            Salvar
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

  import ApplicationTypeService from '@/services/applications/configurations/ApplicationTypeService';
  import ZoneService from '@/services/applications/configurations/ZoneService';
  import { map, find } from 'lodash';

  export default {
    name: 'CreateOrUpdateApplicationType',
    props: ['applicationType', 'mode', 'dialog'],
    components: {},
    mounted() {
      ZoneService
        .all()
        .then(({ data }) => {
          const a = data.map((zone) => {
            return { zone: { name: zone.name }, weight: "0", zone_id: zone.id }
          })
          this.defaultTaxTableZones = a;
        });
    },
    data() {
      return {
        id: null,
        license_id: '',
        acronym: '',
        code: '',
        name: '',
        show_for_selection: false,
        acceptDiscountCompanyType: false,
        taxTableZonesAttributes: [],

        loading: false,
        requiredRules: [
          v => !!v || 'Campo Obrigatório',
        ],
        valid: false,

        defaultTaxTableZones: [],
      };
    },
    methods: {
      save() {
        const payload = {
          id: this.id,
          license_id: this.license_id,
          acronym: this.acronym,
          code: this.code,
          name: this.name,
          show_for_selection: this.show_for_selection,
          accept_discount_company_type: this.acceptDiscountCompanyType,
          tax_table_zones_attributes: this.taxTableZonesAttributes,
        };
        ApplicationTypeService
          .createOrUpdate(payload)
          .then(() => {
            this.$emit('loadPage');
            this.$store.dispatch('toggleSnackbar', {
              show: true,
              color: 'success',
              message: `Tipo de Documento ${ this.snackBarMode } com sucesso`,
              messageIcon: 'mdi-check',
            });
            this.closeDialog();
          })
          .catch(({ response }) => {
            this.$store.dispatch('toggleSnackbar', {
              show: true,
              color: 'error',
              message: response.data.join(', '),
              messageIcon: 'mdi-alert-circle',
            });
          });
      },
      closeDialog() {
        this.$emit('closeDialog');
      },
    },
    computed: {
      dialogTitle() {
        return this.mode === 'create' ? 'Cadastrar' : 'Editar';
      },
      snackBarMode() {
        return this.mode === 'create' ? 'criado' : 'atualizado';
      },
    },
    watch: {
      dialog(newValue) {
        if (newValue) {
          if (this.applicationType !== null) {
            this.id = this.applicationType.id;
            this.license_id = this.applicationType.license_id;
            this.acronym = this.applicationType.acronym;
            this.code = this.applicationType.code;
            this.name = this.applicationType.name;
            this.show_for_selection = this.applicationType.show_for_selection;
            this.acceptDiscountCompanyType = this.applicationType.accept_discount_company_type;

            this.taxTableZonesAttributes = map(this.defaultTaxTableZones, (item) => {
              const taxTableZoneMatched = find(this.applicationType.tax_table_zones, (i) => {
                return i.zone_id === item.zone_id
              });
              return {
                id: taxTableZoneMatched !== undefined ? taxTableZoneMatched.id : null,
                zone_id: item.zone_id,
                weight: taxTableZoneMatched !== undefined ? taxTableZoneMatched.weight : 0,
                zone: item.zone
              }
            })

          } else {
            this.taxTableZonesAttributes = this.defaultTaxTableZones;
          }
        } else {
          this.taxTableZonesAttributes = this.defaultTaxTableZones;
          this.$refs.form.reset();
        }
      },
    },
  };
</script>

<style scoped lang="scss">
</style>
